import { useContext } from "react";
import LangContext from "../../../contexts/LangContext";
import { translate, translateNumber } from "../../../helper";
import "./index.css";

const NotFound = () => {
  const { lang } = useContext(LangContext);
  return (
    <div className="container sh-search-results">
      <div className="sh-error-page">
        <div className="sh-404-image">
          <div>
            <h2>{translateNumber(404, lang)}</h2>
          </div>
        </div>
        <div className="sh-error-content">
          <div className="sh-no-results">
            <h4>{translate("not_found_title", lang)}</h4>
            <p>
              {translate("not_found_desc", lang)} <a href="/result">{translate("not_found_link", lang).replace("[link]", translate("homepage", lang))}</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
